import { SimpleDialog, ButtonLoading } from 'components';
import { Grid, Button } from '@mui/material';
const TimeMessageDg = (props) => {
  const { isOpenTimetDG, setIsOpenTimetDG, timeRamain } = props;
  return (
    <SimpleDialog fullWidth maxWidth="sm" open={isOpenTimetDG} title="مشاهده فایل خروجی">
      <Grid container style={{ textAlign: 'justify' }}>
        امکان درخواست مجدد فایل تا {timeRamain} دقیقه دیگر میسر نمی باشد.
      </Grid>
      <Grid style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse' }}>
        <Button
          variant="contained"
          onClick={() => setIsOpenTimetDG(false)}
          style={{ marginRight: '8px' }}
        >
          بستن
        </Button>
      </Grid>
    </SimpleDialog>
  );
};

export default TimeMessageDg;
